import React from "react";
import { Modal } from "react-bootstrap";
import * as classes from "./CustomMessage.module.scss";
export default function ProductModal(props) {
  return (
    <Modal centered size="md" {...props}>
      <Modal.Header closeButton>Ableaura</Modal.Header>
      <Modal.Body>
        <p className="text-center mb-0">
          All Services & Products Will Be Available For Purchase From August
          15th. Coming Soon, This Independence Day!
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.btnContainer}>
          <div
            className={`btnoutline ${classes.btn} mb-0`}
            onClick={props.onHide}
          >
            <div
              aria-label="ok"
              className={`SubmitBtn ${classes.SubmitBtn}`}
              role="button"
              tabIndex="0"
            >
              OK
            </div>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
